import { ReactNode } from 'react';
import { CustomerProvider } from 'modules/customer';
import { DocumentsProvider, PersonProvider } from 'modules/customer/context';
import { QualificationsProvider } from 'modules/products/context';
import { QualificationChangeProvider } from 'modules/products/context/QualificationChangeProvider';
import { InstallmentsCartProvider } from 'modules/charges/contexts/InstallmentsCartContext';
import { ProviderCompose } from '../ProviderCompose';

interface IDashboardProvidersProps {
  children: ReactNode;
}

/**
 * Providers usados apenas nas rotas que renderizam o Dashboard (cadastros, produtos,
 * operações, etc.). Não são montados na rota de login/auth, reduzindo o peso inicial.
 */
const DashboardProviders = ({ children }: IDashboardProvidersProps) => (
  <ProviderCompose
    contexts={[
      <CustomerProvider key="customer-context" />,
      <PersonProvider key="person-context" />,
      <DocumentsProvider key="documents-context" />,
      <QualificationsProvider key="qualifications-context" />,
      <QualificationChangeProvider key="qualification-change-context" />,
      <InstallmentsCartProvider key="installments-cart-context" />,
    ]}
  >
    {children}
  </ProviderCompose>
);

export default DashboardProviders;
